import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

import {
	ResourcesWrapper,
	Header,
	ResourcesContainer,
	CardsWrapper,
	Container,
	Image,
	Title,
	SubTitile,
	FilterOptions,
	Heading,
	CardsContainer,
	ResourcesWrapperHandheld,
} from "./style";

let stepsResourceData = [];
let selectedCategory = "";

const LearningResources = (props) => {
	const { header, filterHeader } = props;

	const [expandedSteps, setExpandedSteps] = useState([0]);
	const [activeStep, setActiveStep] = useState(0);
	const [stepResources, setStepResources] = useState(null);
	const [resources, setResources] = useState(null);

	useEffect(() => {
		let filteredResources = props.context.data.filter(
			(res) => res.content.tags === props.context.filter_tag[0],
		);
		setResources(filteredResources);
		props.context.filter_tag.forEach((data) => {
			stepsResourceData.push({
				name: data,
				value: props.context.data.filter((res) => res.content.tags === data),
			});
		});
		selectedCategory = stepsResourceData[0]?.name;
		setStepResources(stepsResourceData);
	}, []);

	const handleStepClick = (stepIndex) => {
		setActiveStep(stepIndex);
		const currentExpandedSteps = [...expandedSteps];
		if (expandedSteps.includes(stepIndex)) {
			const index = currentExpandedSteps.indexOf(stepIndex);
			currentExpandedSteps.splice(index, 1);
		} else {
			currentExpandedSteps.push(stepIndex);
		}
		setExpandedSteps(currentExpandedSteps);
	};

	const stopPropagation = (e) => {
		e.stopPropagation();
	};

	const handleClickChange = (e) => {
		selectedCategory = e;
		let filteredResources = props.context.data.filter(
			(res) => res.content.tags === e,
		);
		setResources(filteredResources);
	};

	return (
		<ResourcesWrapper>
			{header && <Header>{header}</Header>}
			<ResourcesContainer>
				<FilterOptions>
					{filterHeader && <Heading>{filterHeader}</Heading>}
					{stepResources?.map((category, index) => (
						<label
							key={index}
							className={
								selectedCategory.includes(category?.name)
									? "selectedCategory"
									: "category"
							}
							onClick={(e) => handleClickChange(category?.name)}
						>
							{category?.name}
						</label>
					))}
				</FilterOptions>
				<CardsContainer>
					<CardsWrapper>
						{resources?.map((card, index) => (
							<Container key={index}>
								<a href={card?.slug} target="_blank">
									<Image>
										<CloudinaryImage
											url={
												card?.content?.body[1]?.components[0]?.cardImage?.image
											}
											quality="auto"
											lazyload
											fetchFormat="auto"
											dpr="5.0"
											sizes={{
												default: {
													height: 348,
												},
											}}
											dynamic
										/>
									</Image>
									<Title>
										{card?.content?.body[1]?.components[0]?.heading}
									</Title>
									<SubTitile>
										{card?.content?.body[1]?.components[0]?.cardText}
									</SubTitile>
								</a>
							</Container>
						))}
					</CardsWrapper>
				</CardsContainer>
			</ResourcesContainer>
			<ResourcesWrapperHandheld
				activeStep={activeStep}
				expandedSteps={expandedSteps}
			>
				<div className="handheldHeading">{filterHeader}</div>
				<div className="stepsWrapper">
					{stepResources &&
						stepResources.map((resourceData, index) => (
							<div
								key={index}
								className="step"
								onClick={() => handleStepClick(index)}
							>
								<div className="stepName">{resourceData?.name}</div>
								<div className="expandArrow">
									<span></span>
								</div>
								<div className="stepDetail" onClick={stopPropagation}>
									<CardsWrapper>
										{resourceData?.value.map((card, index) => (
											<Container key={index}>
												<a href={card?.slug} target="_blank">
													<Image>
														<CloudinaryImage
															url={
																card?.content?.body[1]?.components[0]?.cardImage
																	?.image
															}
															quality="auto"
															lazyload
															fetchFormat="auto"
															dpr="3.0"
															sizes={{
																default: {
																	height: 348,
																},
															}}
															dynamic
														/>
													</Image>
													<Title>
														{card?.content?.body[1]?.components[0]?.heading}
													</Title>
													<SubTitile>
														{card?.content?.body[1]?.components[0]?.cardText}
													</SubTitile>
												</a>
											</Container>
										))}
									</CardsWrapper>
								</div>
							</div>
						))}
				</div>
			</ResourcesWrapperHandheld>
		</ResourcesWrapper>
	);
};

LearningResources.propTypes = {
	header: PropTypes.string,
	filterHeader: PropTypes.string,
};

LearningResources.defaultProps = {
	header: "",
	filterHeader: "",
};

export default LearningResources;
